module.exports = __webpack_public_path__ + "static/img/son3_active.3e7c32ce.png";